import { Message, PendingMessage } from 'Types/message'
import { ChattedCharacterListRes, UserChattedListRes } from 'Types/character'
import { saveTxtWithStatus } from '@/utils/download'
import { formatDateYMD, formatTimestampBracketYMDHMS } from '@/utils/func'

export const isGreetingMessage = (
  message: Message | PendingMessage,
  chatList: Message[],
  isLoadedAllHistory: boolean
) => {
  return (
    isLoadedAllHistory &&
    (message as Message)?.sequence === chatList[0]?.sequence &&
    (message.sender_type === 'character' || message.sender_type === 'story')
  )
}

export const formatMessageFeedbackContent = (
  content: string,
  feedback: string
) => {
  return `${feedback}-${content}`
}

export const filterVisibleChats = (list: ChattedCharacterListRes[]) => {
  return list.filter((item) => item.chat_mode !== 'mini_phone')
}

export const flattenChattedListPages = (
  pages: UserChattedListRes[] | undefined
) => {
  return pages?.flatMap((page) => page.list) || []
}

export const findFirstVisibleCharacterChat = (
  list: ChattedCharacterListRes[]
) => {
  return filterVisibleChats(list).find((item) => item.item_type === 'character')
}

export async function exportChatTxt(
  selectedMsgs: Array<Message | PendingMessage>,
  userNickname?: string,
  characterNickname?: string
): Promise<'saved' | 'canceled' | 'triggered' | 'error'> {
  const textContent: string[] = []
  textContent.push('Date: ' + formatDateYMD())
  textContent.push('Character: ' + (characterNickname || ''))

  selectedMsgs.forEach((msg) => {
    if ('status' in msg) return
    if (msg.sender_type === 'user') {
      textContent.push(
        `${formatTimestampBracketYMDHMS(msg.timestamp)} ${userNickname ?? 'You'}: ${msg.content}`
      )
    } else {
      textContent.push(
        `${formatTimestampBracketYMDHMS(msg.timestamp)} ${characterNickname ?? 'character'}: ${msg.content}`
      )
    }
  })

  if (textContent.length === 0) {
    return 'error'
  }

  const filename = `${characterNickname ?? 'character'}-export-${formatDateYMD()}.txt`
  return saveTxtWithStatus(filename, textContent.join('\n'))
}
